module.exports = __webpack_public_path__ + "img/bullet_1525.85be7979.svg";